






































import Vue from 'vue';
import { EventBus } from '@/event-bus';
import { HelpTrayWrapper } from '@/components/help-tray-components';
import { OverlayWrapper } from '@/components/global-components';
import { PageLoadIndicator } from '@/components/page-components';
import { ModalWrapper } from '@/components/global-modal-components';
import { SkipLinks } from '@/components/accessability-components';
import { dialogMaxWidth } from '@/constants';

interface Data {
  transitionName: string;
  transitionMode: string;
  fullscreenModalVisible: boolean;
  scrollPosition: null | number;
  selfLinks: HTMLBaseElement[];
  leavingSite: boolean;
  leavingSiteModalAction: any;
  dialogMaxWidth: string;
  navTrayOpen: boolean;
  htmlOverflowHiddenClass: string;
}

export default Vue.extend({
  name: 'Root',
  data(): Data {
    return {
      transitionName: 'page-fade',
      transitionMode: 'out-in',
      fullscreenModalVisible: false,
      scrollPosition: null,
      selfLinks: [],
      leavingSite: false,
      leavingSiteModalAction: null,
      dialogMaxWidth,
      navTrayOpen: false,
      htmlOverflowHiddenClass: 'overflow-hidden-overlay-wrapper',
    };
  },
  mounted() {
    EventBus.$on('closeOverlayWrapper', this.fullscreenHidden);
    // Toggle navTrayOpen flag
    EventBus.$on('openNavTray', () => {
      this.navTrayOpen = true;
    });
    EventBus.$on('closeNavTray', () => {
      this.navTrayOpen = false;
    });
    EventBus.$on('routeClick', (to) => {
      this.$router.push({name: to});
    });
  },
  methods: {
    cancelLeaveSite(): void {
      this.leavingSite = false;
      this.leavingSiteModalAction = null;
    },
    leaveSite(): void {
      window.location = this.leavingSiteModalAction;
    },
    fullscreenHidden(): void {
      if (this.fullscreenModalVisible) {
        this.fullscreenModalVisible = false;
        this.removeHTMLOverflowHidden();
        setTimeout(() => {
          window.scrollTo(0, this.scrollPosition);
          this.scrollPosition = 0;
        }, 0);
      }
    },
    fullscreenVisible(): void {
      this.scrollPosition = window.pageYOffset;
      this.fullscreenModalVisible = true;
      this.addHTMLOverflowHidden();
    },
    addHTMLOverflowHidden(): void {
      document.documentElement.classList.add(this.htmlOverflowHiddenClass);
    },
    removeHTMLOverflowHidden(): void {
      document.documentElement.classList.remove(this.htmlOverflowHiddenClass);
    },
    createWarningModalLinks(): void {
      setTimeout(() => {
        const NEW_SELF_LINKS = document.querySelectorAll<HTMLBaseElement>('[data-leaving-warning]');

        Array.from(NEW_SELF_LINKS).forEach((link) => {
          if (!this.selfLinks.includes(link)) {
            link.addEventListener('click', (event) => {
              event.preventDefault();

              this.leavingSiteModalAction = link.href;
              this.leavingSite = true;
            });

            this.selfLinks.push(link);
          }
        });
      }, 0);
    },
  },
  components: {
    HelpTrayWrapper,
    PageLoadIndicator,
    OverlayWrapper,
    ModalWrapper,
    SkipLinks,
  },
  watch: {
    $route(to) {
      this.transitionMode = to.meta.transitionMode
        ? to.meta.transitionMode
        : 'out-in';
      this.transitionName = to.meta.transitionIn
        ? to.meta.transitionIn
        : 'page-fade';

      this.navTrayOpen = false;

      this.createWarningModalLinks();
    },
  },
});
